import API from "..";
import { checkAPIResponse } from "../helpers";

export default class UserHomeSite {
   /**
   * User Home Site management
   * @param {String} userEmail 
   * @param {String} siteName 
   */
    constructor({
      userEmail,
      siteName
    }) {
      this.userEmail = userEmail;
      this.siteName = siteName;
    }

    static async GetUsersByHomeSite(siteName) {
      const api = await API();
      const response = await api.get(`/userhomesite/${siteName}`);
      checkAPIResponse(response);
      const result = response.data.result;
      return result ? result.map((d) => new UserHomeSite(d)) : [];
    }

    static async CreateOrUpdateUserHomeSite(userEmail, siteName) {
      const api = await API();
      const response = await api.post(`/userhomesite/${userEmail}`, siteName);
      checkAPIResponse(response);
      return response.data.result;
    }

    static async DeleteUserHomeSite(userEmail) {
      const api = await API();
      const response = await api.delete(`/userhomesite/${userEmail}`);
      checkAPIResponse(response);
      return response.data.result;
    }
}
